/**
 * 로그인 페이지 회사 선택용 쿠키 유틸리티
 * - 마지막 로그인 회사 코드를 쿠키에 저장/조회
 * - 브라우저 재시작 후에도 회사 선택을 자동으로 채우기 위함
 */

const COOKIE_NAME = 'lastCompanyCode';
const MAX_AGE_ONE_YEAR = 365 * 24 * 60 * 60; // 1년(초)

/**
 * 쿠키에서 마지막 로그인 회사 코드를 읽습니다.
 * 저장 시 encodeURIComponent 되었으므로 읽을 때 decodeURIComponent 적용
 * @returns {string|null} 회사 코드 문자열 또는 없으면 null
 */
function getLastCompanyCode() {
  if (typeof document === 'undefined' || !document.cookie) {
    return null;
  }
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  const raw = match ? match[1].trim() : null;
  if (!raw) return null;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

/**
 * 마지막 로그인 회사 코드를 쿠키에 저장합니다.
 * 로그인할 때마다 갱신됩니다.
 * @param {string|number} companyCode - 회사 코드
 */
function setLastCompanyCode(companyCode) {
  if (typeof document === 'undefined') {
    return;
  }
  const value = String(companyCode ?? '').trim();
  if (!value) {
    document.cookie = `${COOKIE_NAME}=; path=/; max-age=0`;
    return;
  }
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; path=/; max-age=${MAX_AGE_ONE_YEAR}; SameSite=Lax`;
}

export { getLastCompanyCode, setLastCompanyCode };
